import { ComponentProps } from "react";
import { Field, FieldDescription, FieldLabel } from "../ui/field";
import { FieldErrors, FieldProps } from "./field";
import { CpySelect } from "@/services/backend/cpy/components/cpy-select";
import { useFieldErrors } from "@/shared/lib/errors/err-validation-failed-context";

/*
 * CpySelectField wraps CpySelect in a shadcn/ui
 * Field component.
 */
export function CpySelectField({
  label,
  description,
  errors: ownErrors,
  fieldName,
  fieldProps,
  onSelect,
  onValueReset,
  ...props
}: {
  label: string;
} & ComponentProps<typeof CpySelect> &
  FieldProps) {
  const { errors, invalid, reset } = useFieldErrors(fieldName, ownErrors);

  return (
    <Field data-invalid={invalid || undefined} {...fieldProps}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <CpySelect
        invalid={invalid}
        {...props}
        onSelect={(sourceId) => {
          reset();
          onSelect?.(sourceId);
        }}
        onValueReset={
          onValueReset &&
          (() => {
            reset();
            onValueReset();
          })
        }
      />
      {description && <FieldDescription>{description}</FieldDescription>}
      <FieldErrors errors={errors} />
    </Field>
  );
}
